<template>
     <div class="report-middleware">
        <loader-full></loader-full>
    </div>
</template>
<script>
import LoaderFull from '../Loaders/LoaderFull.vue'
import analyzeApi from '../../api/analyze'
import decodeApi from '../../api/decode'
import { sendKenobyResult } from '../../helpers/integrationManager'
export default {
    components:{
        LoaderFull
    },
    async created(){
        try {
            const { workspaceId, userId, player, teamGameId } = await this.$store.getters.getSimple(['workspaceId', 'userId', 'player', 'teamGameId'])
            const hasReport = JSON.parse(localStorage.getItem('hasReport'))
            let report = ''
            let playStyleResponse
            // let gupyService = JSON.parse(localStorage.getItem("gupyServiceInfo"))
            if(!teamGameId){
                const sessionId = localStorage.getItem("sessionId")
                const getTG = await decodeApi.get(`/team-games/by-user?sessionId=${sessionId}&userId=${userId}`)

                const teamGameIdByUser = getTG.data.teamGame.id
                this.teamGameId = teamGameIdByUser
            } else {
                this.teamGameId = teamGameId
            }

            if(!hasReport){
                report = await analyzeApi.post(`decode-reports`, {
                    user : player,
                    workspaceId,
                    teamGameId: this.teamGameId
                })
                // console.log(report)
                playStyleResponse = report.data.decodeReport.playStyle
                if(localStorage.getItem("kenobyInfoId")) 
                    await sendKenobyResult(localStorage.getItem("kenobyInfoId"), teamGameId, workspaceId, player)
            }else{
                report = await analyzeApi.get(`decode-reports?userId=${userId}&workspaceId=${workspaceId}`)
                // console.log(report)
                playStyleResponse = report.data.decodeReport.playStyle
            }
            // if(gupyService) window.open(gupyService.callback_url, "_blank");
            
            // console.log(playStyleResponse)
            const playStyle = [
                playStyleResponse.cooperator,
                playStyleResponse.friendly,
                playStyleResponse.researcher, 
                playStyleResponse.planner,
                playStyleResponse.listener,
            ]
            // console.log(playStyle)
            const antagonisticReport = this.antagonisticReport(playStyle)
            await this.$store.dispatch('simpleSave', {
                reportPlayStyle : playStyleResponse,
                antagonisticReport 
            })
            this.$router.push(`/report/graphic`)
        } catch (error) {
            //TODO: make a error message showing up instead console.log error
            // console.log(error)
        }
    },
    methods: {
        antagonisticReport(playStyle){
            let maxValue = 5
            let reportData = playStyle 
            let reportReturn = []
            playStyle.forEach(playStyleItem => {
                reportData.push(maxValue - playStyleItem)
            });
            reportReturn.push(
                reportData[0],
                reportData[9],
                reportData[8],
                reportData[7],
                reportData[6],
                reportData[5],
                reportData[4],
                reportData[3],
                reportData[2],
                reportData[1]
            )
            // console.log(reportReturn)

            return reportReturn
        }
    }
}
</script>
<style lang="scss" scoped>

</style>
